// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const UserManagement = reactLazyRetry(
  () => import('./userManagement/pages/UserManagement')
);
const AppManagement = reactLazyRetry(
  () => import('./appManagement/pages/AppManagement')
);

/**
 * Administrative Options route definitions and metadata used by the
 * application router and permission-aware navigation (QuickLinks).
 */
export const administrativeOptionsRoutes = [
  {
    name: 'User Management',
    key: 'userManagement',
    path: DEFAULT_ROUTE_CONFIG?.userManagement?.path || 'user-management',
    element: <UserManagement />,
    permission: 'AdministrativeOptions_userManagement',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
  {
    name: 'App Management',
    key: 'appManagement',
    path: DEFAULT_ROUTE_CONFIG?.appManagement?.path || 'app-management',
    element: <AppManagement />,
    permission: 'AdministrativeOptions_appManagement',
    quickLink: {
      enabled: true,
      action: 'list',
    },
  },
];
